import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowLeft, CheckCircle } from 'lucide-react';
import apiService from '../../services/api';
import '../../styles/login.scss';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!email) { setError('Ingresa tu correo'); return; }
    setLoading(true);
    try {
      await apiService.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err: any) {
      setError(err?.response?.data?.message || 'No se pudo procesar la solicitud');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container flex items-center justify-center py-12 px-4">
      <div className="login-box">
        <div className="login-logo">
          <img src="/img/mitsui_logo_corporate.svg" alt="MITSUI & CO." />
        </div>

        {sent ? (
          <div style={{ textAlign: 'center' }}>
            <CheckCircle size={40} style={{ color: 'var(--green)', margin: '0 auto 12px' }} />
            <h3 style={{ marginBottom: 8 }}>Revisa tu correo</h3>
            <p style={{ color: 'var(--text-secondary)', fontSize: 14, lineHeight: 1.6 }}>
              Si <strong>{email}</strong> está registrado, te enviamos un enlace para restablecer tu contraseña.
              El enlace vence en 1 hora.
            </p>
            <Link to="/login" className="forgot-password" style={{ display: 'inline-flex', alignItems: 'center', gap: 6, marginTop: 20 }}>
              <ArrowLeft size={16} /> Volver a iniciar sesión
            </Link>
          </div>
        ) : (
          <>
            <div className="login-header">
              <p>Restablecer contraseña · te enviaremos un enlace por correo</p>
            </div>
            <form onSubmit={handleSubmit}>
              {error && <div className="error-message"><span className="error-text">{error}</span></div>}
              <div className="form-group">
                <label htmlFor="email">Correo electrónico</label>
                <div className="input-wrapper">
                  <Mail className="input-icon" />
                  <input id="email" type="email" value={email}
                    onChange={(e) => setEmail(e.target.value)} placeholder="tu@email.com" required />
                </div>
              </div>
              <button type="submit" disabled={loading} className="login-button">
                {loading ? 'Enviando…' : 'Enviar enlace'}
              </button>
              <div className="register-link">
                <Link to="/login" className="forgot-password" style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                  <ArrowLeft size={16} /> Volver a iniciar sesión
                </Link>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
